import { STRATEGY_PILLARS } from "@/lib/content";
import { ASSETS } from "@/lib/assets";
import ResponsibleBanner from "@/components/ResponsibleBanner";
import { Hammer } from "lucide-react";

export default function StrategyPage() {
  return (
    <div className="max-w-[1200px] mx-auto px-4 sm:px-6 py-14 space-y-12">
      <section className="grid md:grid-cols-[1fr_260px] gap-8 items-center">
        <div>
          <div className="text-xs font-bold tracking-[0.2em] text-smasher-orange mb-2">PROPRIETARY EDUCATION</div>
          <h1 className="font-heading font-black uppercase text-4xl sm:text-6xl text-gradient-gold mb-4">The Smasher Strategy</h1>
          <p className="text-lg text-slate-300 leading-relaxed">Sportsbook Smasher is about learning how to analyze the game before you make the wager. It's not about blindly placing bets — it's research, discipline, understanding lines, and managing your bankroll.</p>
        </div>
        <img src={ASSETS.hammerBadge} alt="Smasher hammer" className="w-40 mx-auto object-contain drop-shadow-[0_8px_24px_rgba(255,138,0,0.4)]" />
      </section>

      <section className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {STRATEGY_PILLARS.map((p) => (
          <div key={p.title} className="panel panel-hover p-5">
            <Hammer className="w-6 h-6 text-smasher-gold mb-2" />
            <h3 className="font-heading font-bold text-lg text-white">{p.title}</h3>
            <p className="text-sm text-slate-400 mt-1 leading-relaxed">{p.body}</p>
          </div>
        ))}
      </section>

      <div className="panel p-6 border-smasher-gold/25">
        <p className="text-slate-300 leading-relaxed"><span className="font-heading font-black text-smasher-gold text-lg">No guarantees.</span> The Smasher Strategy does not claim guaranteed profits or winning percentages. It focuses on identifying value, avoiding emotional betting, and making informed decisions. Every wager carries risk.</p>
      </div>

      <ResponsibleBanner />
    </div>
  );
}
